import { ChangeDetectionStrategy, Component, output, viewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-proroga-overlay',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-overlayPanel [dismissable]="false">
    <p>Proroga al:</p>
    <p-calendar [showIcon]="true" dateFormat="dd/mm/yy" [minDate]="oggi"
      [selectOtherMonths]="true" appendTo="body" [(ngModel)]="value">
    </p-calendar>
    <div style="text-align: right; margin-top: 10px; border-top: 1px solid lightgrey; padding-top: 10px;">
      <button pButton type="button" label="Annulla" class="p-button-secondary" (click)="panel().hide()"></button>
      <button pButton type="button" label="Proroga" class="p-button-primary" (click)="onProrogaClick()"></button>
    </div>
  </p-overlayPanel>
  `
})

export class ProrogaOverlayComponent {
  panel = viewChild.required(OverlayPanel);
  proroga = output<{ id: number, date: Date }>();

  public id = 0;
  public value = new Date();
  public oggi = new Date();

  toggle(event: unknown, id: number, date: Date): void {
    this.id = id;
    this.value = date;
    this.panel().toggle(event);
  }

  onProrogaClick(): void {
    this.proroga.emit({ id: this.id, date: this.value });
    this.panel().hide();
  }
}
